import { alpha as MuiAlpha } from '@material-ui/core/styles';
import { logInDev } from '../utils';
/**
 * opacity
 * @param values
 */
export function opacity(name, reverse) {
    return function (_a) {
        var theme = _a.theme;
        var value = theme.opacity[name];
        if (reverse) {
            return 1 - value;
        }
        return value;
    };
}
/**
 * inner method
 */
export function doAlpha(color, opacity, theme) {
    var alpha = String(opacity).indexOf('.') > -1
        ? opacity
        : theme.palette.action.hoverOpacity * opacity;
    try {
        return MuiAlpha(color, +alpha.toFixed(2));
    }
    catch (error) {
        if (process.env.NODE_ENV !== 'production') {
            logInDev({
                component: 'setOpacity',
                message: 'your color pass into setOpacity is error color, check your color again, please',
            });
        }
        return color;
    }
}
